import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import useFreightInformation from '@/shared/product/freight-information/useFreightInformation';
import FreightInfoButton from '@/shared/product/freight-information/ui/FreightInfoButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSpotFreightInformation',
  props: {
    sku: null
  },
  setup(__props: any) {

const props = __props as {
    sku: string;
}



const { getHasFreightInfo } = useFreightInformation();
const hasFreightInformation = computed(() => getHasFreightInfo(props.sku));


return (_ctx: any,_cache: any) => {
  return (_unref(hasFreightInformation))
    ? (_openBlock(), _createBlock(FreightInfoButton, {
        key: 0,
        "button-css": "o-text-caption c-link text-left relative z-2",
        "has-freight-information": _unref(hasFreightInformation)
      }, null, 8, ["has-freight-information"]))
    : _createCommentVNode("", true)
}
}

})